import { SharedContext } from '@leverege/ui-plugin'
import React, { useMemo } from 'react'

export default function AnalyticsContext( { store, children } ) {
  const { timezone, operatingHours } = useMemo( () => {
    const operatingHoursModel = store?.data?.metadata?.operatingHours?.default
    return {
      timezone : operatingHoursModel?.timezone || 'America/Phoenix',
      operatingHours : operatingHoursModel
    }
  }, [ store ] )

  return (
    <SharedContext
      timezone={timezone}
      operatingHours={operatingHours}>
      {children}
    </SharedContext>
  )
}
